import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';

function TimePicker(props) {
  const { label, value, onChange } = props;

  return (
    <TextField
      id="time"
      label={label}
      type="time"
      inputProps={{
        step: 300, // 5 min
      }}
      InputLabelProps={{
        shrink: true,
      }}
      value={value}
      onChange={(evt) => onChange(evt.target.value) }
    />
  );
}

TimePicker.propTypes = {
  label: PropTypes.string.isRequired,
};

export default TimePicker;


// WEBPACK FOOTER //
// ./src/components/Common/TimePicker/index.js